




































import Vue from "vue";
import { SimpleListItem } from "@/types/simpleListItem";
export default Vue.extend({
    name: "PortalNavButtonsArea",
    props: {
        multiline: Boolean,
        items: { type: Array as () => SimpleListItem[] },
        icon: String,
        iconClass: String,
        portalId: Number
    },
    data: () => ({
        selectedItem: -1
    }),
    created() {
        if (this.items && this.items.some(item => item.selected)) this.selectedItem = this.items.findIndex(item => item.selected);
    },
    watch: {},
    computed: {},
    methods: {
        getIconColor(item: any) {
            return item.iconColor ? item.iconColor : "primary";
        },
        getRedirectToPortalUrl(portalId: Number): String {
            const routeData = this.$router.resolve({ name: "Portal", params: { portalId: portalId.toString() } });
            return routeData.href;
        }
    }
});
